export { default } from './ModalCompleteProfile';
